import { useMemo, type FC } from 'react';

import dynamic from 'next/dynamic';

import { TabPanel } from '@mui/lab';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';

import { t } from '@/utils/lang';
import type { EntityComponentProps } from '../../types/EntityComponent.types';
import DeviceInfo from './Detail/DeviceInfo';
import TabContainer from './Tabs/Common/TabContainer';

const Task = dynamic(() => import('./Tabs/Device/Task'), {
    ssr: false,
});

const Assignee = dynamic(() => import('./Tabs/Customer/Assignee'), {
    ssr: false,
});

const DeviceEntityContent: FC<EntityComponentProps> = ({ data }) => {
    const propsTask = useMemo(() => {
        let assignee = null;
        let assigneeId = null;

        // PRIORITY ASSIGNEE IN DEVICE ELSE PRIORITY ASSIGNEE IN CUSTOMER
        if (data?.assignee) {
            assignee = data?.assignee;
            assigneeId = data?.assigneeId;
        } else if (data?.customer?.leadTechnician) {
            assignee = data?.customer?.leadTechnician;
            assigneeId = data?.customer?.leadTechnicianId;
        }

        return {
            addNewTask: true,
            customerId: data?.customerId,
            deviceId: data?.id,
            device: data,
            assigneeId,
            assignee,
        };
    }, [data]);

    return (
        <Box>
            <DeviceInfo data={data} />
            <TabContainer
                defaultTab='tasks'
                tabPanels={
                    <>
                        <TabPanel value='tasks'>
                            <Task {...propsTask} />
                        </TabPanel>
                        <TabPanel value='assignees'>
                            <Assignee
                                customerId={data?.customerId}
                                deviceId={data?.id}
                            />
                        </TabPanel>
                    </>
                }
            >
                <Tab label={t('Tasks')} value='tasks' />
                <Tab label={t('Kỹ thuật viên')} value='assignees' />
            </TabContainer>
        </Box>
    );
};

export default DeviceEntityContent;
